/*
  Scroll-reveal only for the reusable cross-sell section — no other
  interactivity needed, hover states are pure CSS.
*/
(function () {
  "use strict";

  function init(root) {
    root.classList.add("js");
    var targets = [].slice.call(root.querySelectorAll(".r"));
    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add("in"); io.unobserve(entry.target); }
      });
    }, { rootMargin: "0px 0px 200px 0px", threshold: 0 });
    targets.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    document.querySelectorAll("[data-v2g-cross-sell]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", boot);
  }
})();
